import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import administracao from './administracao'
import cadastro from './cadastro'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            meta: {title: 'Acesso náo permitido'},
            name: '403',
            path: '/403',
            component: () => import(/* webpackChunkName: '403' */  '@/views/errors/403')
        },
        {
            meta: {title: 'Página não encontrada'},
            name: '404',
            path: '*',
            component: () => import(/* webpackChunkName: '404' */ '@/views/errors/404')
        },
        {
            meta: {authenticated: true, layout: 'admin', title: 'Dashboard'},
            name: 'dashboard',
            path: '/dashboard',
            component: () => import(/* webpackChunkName: 'dashboard' */ '@/views/Dashboard'),
        },
        {
            meta: {layout: 'login', title: 'Login'},
            name: 'login',
            path: '/login/:cliente',
            component: () => import(/* webpackChunkName: 'login' */ '@/views/autenticacao/Login'),
        },
        {
            meta: {authenticated: true, layout: 'admin', title: 'Meu perfil'},
            name: 'perfil-edit',
            path: '/perfil/edit',
            component: () => import(/* webpackChunkName: 'perfil' */ '@/views/Perfil'),
        },
        {
            meta: {layout: 'login', title: 'Recuperar senha'},
            name: 'recuperar-senha',
            path: '/recuperar-senha/:cliente',
            component: () => import(/* webpackChunkName: 'recuperar-senha' */ '@/views/autenticacao/RecuperarSenha'),
        },
        {
            meta: {authenticated: true, layout: 'login', title: 'Trocar senha'},
            name: 'trocar-senha',
            path: '/trocar-senha',
            component: () => import(/* webpackChunkName: 'dashboard' */ '@/views/autenticacao/TrocarSenha'),
        },
        ...administracao,
        ...cadastro,
    ],
})

router.beforeEach((to, from, next) => { 
    const usuario = store.state.usuario

    if (to.name != 'trocar-senha' && usuario && usuario.trocar_senha == true) {
        next('/trocar-senha')
    }

    if (to.matched.some(record => record.meta.authenticated)) {
        const token = store.state.token

        if (token === null) {
            const cliente = store.state.cliente

            if (cliente) {
                next(`/login/${cliente.link}`)
            }

            next('/404')
        }
    }

    if (to.params && to.params.notification !== false) {
        if ((from.path.includes('create') || from.path.includes('edit')) && !to.path.includes('login')) {
            store.dispatch('createNotification', {
                type: 'dialog',
                persistent: true,
                color: 'warning',
                title: 'Confirmação',
                message: 'As informações não salvas serão perdidas. Deseja realmente sair?',
                onConfirm: async () => {
                    next()
                },
                onCancel: null,
                onError: null,
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

router.afterEach((to) => {
    document.title = 'ConectaCidadão - ' + to.meta.title
})

export default router